import { SvgIcon, SvgIconProps } from "@mui/material";

export const HomeFilledIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.083 23.917v-5.25A2.916 2.916 0 0 1 14 15.75v0a2.916 2.916 0 0 1 2.917 2.917v5.25h6.416V13.9c0-.619-.246-1.213-.683-1.65l-7.825-7.825a1.165 1.165 0 0 0-1.65 0L5.35 12.25a2.334 2.334 0 0 0-.683 1.65v10.017h6.416Z"
        clipRule="evenodd"
      />
    </svg>
  </SvgIcon>
);
